<template>
  <div>
    <div class="mr-r30" style="float:left; width: 250px; ovweflow: hidden;">
      <div class="title-h3 title-bar" style="height:30px; line-height:30px;">중요 프로세스 템플릿</div>
      <hr class="mr-b20" />
      <w-major-proc-type-tree   ref="sideTree" @nodeAddType="nodeAddType" @nodeUpdateType="nodeUpdateType" @nodeDeleteType="nodeDeleteType" @clickNode="onClickNode" slot="side"/>
    </div>
    <w-major-proc-template-list style="float:right; width: calc(100% - 280px);" :selectPhysicalNode="selectPhysicalNode"></w-major-proc-template-list>
    <w-tree-proc-type-popup ref="treeProcTypePopup" @reload-data="loadTreeData" :editData="editData" :majorProcTypeId="majorProcTypeId" :selectPhysicalNode="selectPhysicalNode" :popup-type="treeProcPopupType"></w-tree-proc-type-popup>
  </div>
</template>

<script>
import WPanel from '@/components/box/Panel';
import cloneDeep from 'lodash/cloneDeep';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import WSettingContentSideTemplate from '@/views/settings/components/template/SettingContentSideTemplate';
import WMajorProcTypeTree from '@/views/settings/server/ProcessSettings/MajorProcessRegistView/component/MajorProcTypeTree';
import WMajorProcTemplateList from '@/views/settings/server/ProcessSettings/MajorProcessRegistView/component/MajorProcTemplateList';
import WTreeProcTypePopup from '@/views/settings/server/ProcessSettings/MajorProcessRegistView/popup/TreeProcTypePopup';

export default {
  name: 'WProcessTemplateSettingView',
  components: {
    WPanel,
    WSettingContentSideTemplate,
    WMajorProcTypeTree,
    WMajorProcTemplateList,
    WTreeProcTypePopup,
  },
  props: {
    activeTab: String,
  },
  data() {
    return {
      editData: {},
      nodeData: null,
      selectPhysicalNode: null,
      firstKey: null,
      treeProcPopupType: null,
      majorProcTypeId: null,
    };
  },
  watch: {
    activeTab: {
      handler() {
        this.loadTreeData();
      },
      immediate: true,
    },
  },
  methods: {
    loadTreeData() {
      if (this.activeTab === this.$options.name) {
        this.$refs.sideTree.loadTree();
      }
    },
    onClickNode(data) {
      this.selectPhysicalNode = cloneDeep(data);
    },
    nodeAddType(data) {
      this.editData = {};
      this.majorProcTypeId = data.majorProcTypeId;
      this.treeProcPopupType = 'ADD';
      this.$refs.treeProcTypePopup.open();
    },
    nodeUpdateType(data) {
      this.editData = data;
      this.majorProcTypeId = data.majorProcTypeId;
      this.treeProcPopupType = 'EDIT';
      this.$refs.treeProcTypePopup.open();
    },
    nodeDeleteType(data) {
      this.$confirm('삭제하시겠습니까?', '삭제', {
        confirmButtonText: '삭제',
        cancelButtonText: '취소',
      }).then(() => {
        ServerSettingAPI.deleteMajorProcessType({ majorProcTypeId: data.majorProcTypeId }).then((response) => {
          if (response.data.success) {
            this.loadTreeData();
          }
        });
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/MajorProcessRegistView/ProcessTemplateSettingView.vue